export default __webpack_public_path__ + "static/media/systemOfTaxImg.55ccd6b8.svg";